module.exports = __webpack_public_path__ + "img/explore-11.bf6095ef.jpg";